<template>
  <v-text-field
    ref="search"
    class="search-input search-toggle"
    :class="{
      open: alwaysOpen || searchOpen,
      large: large,
      'background-dark': dark,
    }"
    prepend-icon="search"
    :value="value"
    @input="handleSearch"
    :placeholder="placeholder"
    clear-icon="cancel"
    clearable
    :autocomplete="false"
    @click:prepend="toggleActive"
    :autofocus="autofocus"
    @keypress.enter="$emit('submit')"
    @click:clear="$emit('cleared')"
  />
</template>

<script>
import debounce from 'lodash/debounce';

export default {
  name: 'SearchToggleField',
  props: {
    value: {},
    placeholder: {
      type: String,
      default: 'Search',
    },
    alwaysOpen: Boolean,
    dark: Boolean,
    large: Boolean,
    addQuery: Boolean,
    autofocus: Boolean,
    delay: {
      type: Number,
      default: 200,
    },
  },
  data() {
    return {
      searchDelay: null,
      searchOpen: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal && !oldVal) {
          this.searchOpen = true;
        }
        this.updateQuery();
      },
    },
  },
  methods: {
    handleSearch(value) {
      clearTimeout(this.searchDelay);

      this.searchDelay = setTimeout(() => {
        this.$emit('input', value || '');
      }, this.delay);

      if (value && !this.searchOpen) {
        this.searchOpen = true;
      }
    },

    updateQuery: debounce(function () {
      if (this.addQuery && 'URLSearchParams' in window) {
        let searchParams = new URLSearchParams(window.location.search);

        if (this.value) {
          searchParams.set('search', this.value || '');
        } else {
          searchParams.delete('search');
        }

        let newPath = window.location.pathname;
        const searchStr = searchParams.toString();

        if (searchStr) {
          newPath += `?${searchStr}`;
        }

        history.pushState(null, '', newPath);
      }
    }, 100),

    toggleActive() {
      if (this.alwaysOpen) return;
      this.searchOpen = !this.searchOpen;

      setTimeout(() => {
        if (this.searchOpen) {
          this.$refs.search.focus();
          this.$refs.search.$el.click();
        }
      }, 250);
    },
  },
};
</script>

<style lang="less">
div.search-toggle.v-input {
  width: 240px;
  max-width: 240px;
  transition: width 0.2s ease;

  @media only screen and (max-width: 980px) {
    width: 190px;
    max-width: 190px;
  }

  .v-input__slot {
    height: 36px;
    padding: 6px 15px 6px 40px;
    margin-bottom: 0 !important;
  }

  div.v-input__prepend-outer {
    height: 100%;
    width: 36px;
    top: 0;
    left: 0;
    margin: 0;
    display: flex;
    align-items: center;
    cursor: pointer;

    button.v-icon {
      color: var(--v-appMain-base) !important;
    }
  }

  &.large {
    width: 100%;
    max-width: 100%;
  }

  &:not(.open) {
    width: 40px;
    flex: none;
    overflow: hidden;
    border-radius: @base-radius;
    transition: width 0.2s ease;

    .v-input__slot {
      padding-right: 0;
    }
  }

  .v-input__append-inner {
    margin-top: 0 !important;
    margin-right: -4px !important;
  }
}
</style>
